import { Utils } from './restaurant-manager.utils';
import { LibConfiguration } from './services/api.service';
import * as moment_ from 'moment';
const moment = moment_;
import { v4 as uuidv4 } from 'uuid';

export class Extension {
  static readonly EVENTS = 'events';
  static readonly GROUPED_PAYMENTS = 'grouped_payments';
  static readonly POS = 'pos';
  static readonly DELIVERY_TRACKER = 'delivery_tracker';
  static readonly SLOTS = 'slots';
  static readonly STOCKS = 'stocks';
  static readonly CLICK_COLLECT = "click_collect";
  static readonly KITCHEN_PRODUCTION = "kitchen_production";
  static readonly MENU = 'menu';
}

export abstract class Sortable {
  position: number;
}

export const ZONE_OBJECT_TYPES = {
  flowers_pot: {
    slug: 'flowers_pot',
    label: 'Pot de fleurs',
    image: 'flower1'
  },
  wc: {
    slug: 'wc',
    label: 'WC',
    image: 'badge-wc'
  }
}

export const PAYMENT_METHODS = {
  rticket: {
    slug: 'rticket',
    label: 'Ticket restaurant',
    shortLabel: 'Ticket R',
    icon: 'receipt'
  },
  cash: {
    slug: 'cash',
    label: 'Espèces',
    shortLabel: 'Espèces',
    icon: 'coin'
  },
  card: {
    slug: 'card',
    label: 'Carte bancaire',
    shortLabel: 'Carte',
    icon: 'credit-card'
  },
  check: {
    slug: 'check',
    label: 'Chèque',
    shortLabel: 'Chèque',
    icon: 'credit-card-2-front'
  },
  account: {
    slug: 'account',
    label: 'Mise en compte',
    shortLabel: 'Compte',
    icon: 'person'
  },
  other: {
    slug: 'other',
    label: 'Autre',
    shortLabel: 'Autre',
    icon: 'three-dots'
  }
}

export const ORDER_STATUS = {
  pending: {
    slug: 'pending',
    label: 'En attente de paiement'
  },
  confirmed: {
    slug: 'confirmed',
    label: 'Confirmée'
  },
  preparing: {
    slug: 'preparing',
    label: 'En cours de préparation'
  },
  delivering: {
    slug: 'delivering',
    label: 'En cours de livraison'
  },
  done: {
    slug: 'done',
    label: 'Terminée'
  },
  cancelled: {
    slug: 'cancelled',
    label: 'Annulée'
  }
};

export const ORDER_CANCELLATION_REASONS = {
  typing_error: {
    slug: 'typing_error',
    label: 'Erreur saisie'
  },
  client_issue: {
    slug: 'client_issue',
    label: 'Problème client'
  },
  product_non_available: {
    slug: 'product_non_available',
    label: 'Produit indisponible'
  },
  other: {
    slug: 'other',
    label: 'Autre'
  }
};

export const PERMISSIONS = {
  team: {
    cancel_order: {
      slug: 'cancel_order',
      label: 'Annulation commande'
    },
    cancel_transaction: {
      slug: 'cancel_transaction',
      label: 'Annulation transaction'
    },
    apply_discount: {
      slug: 'apply_discount',
      label: 'Application de remise'
    },
    show_stats: {
      slug: 'show_stats',
      label: 'Affichage des statistiques'
    }
  }
}

export const PRODUCT_DIMENSION_TYPES = {
  unit: {
    slug: 'unit',
    label: 'Produit à l\'unité'
  },
  kg: {
    slug: 'kg',
    label: 'Produit au poids'
  },
  m: {
    slug: 'unit',
    label: 'Produit au mètre'
  }
}

export const POS_REPORT_ACTIONS = {
  create_order: {
    slug: 'create_order',
    label: 'a crée une commande'
  },
  cancel_order: {
    slug: 'cancel_order',
    label: 'a annulé une commande'
  },
  close_order: {
    slug: 'close_order',
    label: 'a clôturé une commande'
  },
  cancel_partial_order: {
    slug: 'cancel_partial_order',
    label: 'a annulé les produits de la commande'
  },
  add_order_item: {
    slug: 'add_order_product',
    label: 'a ajouté un produit'
  },
  delete_order_item: {
    slug: 'delete_order_item',
    label: 'a supprimé un produit'
  },
  create_transaction: {
    slug: 'create_transaction',
    label: 'a crée une transaction'
  },
  cancel_transaction: {
    slug: 'cancel_transaction',
    label: 'a annulé une transaction'
  },
  apply_discount: {
    slug: 'apply_discount',
    label: 'a appliqué une remise'
  },
  cancel_discount: {
    slug: 'cancel_discount',
    label: 'a retiré une remise'
  },
  print_order_ticket: {
    slug: 'print_order_ticket',
    label: 'a imprimé un ticket de commande'
  },
  print_transaction_ticket: {
    slug: 'print_transaction_ticket',
    label: 'a imprimé un ticket de transaction'
  },
  create_z_ticket: {
    slug: 'create_z_ticket',
    label: 'a crée un ticket Z'
  },
  print_z_ticket: {
    slug: 'print_z_ticket',
    label: 'a imprimé un ticket Z'
  },
  login_employee: {
    slug: 'login_employee',
    label: 's\est connecté'
  },
  logout_employee: {
    slug: 'logout_employee',
    label: 's\est déconnecté'
  },
  open_session: {
    slug: 'open_session',
    label: 'a ouvert une session'
  },
  close_session: {
    slug: 'close_session',
    label: 'a clôturé une session'
  },
  open_drawer: {
    slug: 'open_drawer',
    label: 'a ouvert le tiroir caisse'
  },
  open_table: {
    slug: 'open_table',
    label: 'a ouvert une table'
  },
  close_table: {
    slug: 'close_table',
    label: 'a fermé une table'
  }
}

export const ORDER_STATUS_INFORMATIONS = {
  ROLE_USER: {
    pending: 'Votre commande n\'est pas validée et est en attente de règlement. Vous pouvez à tout moment la payer au bas de cette page.',
    confirmed: 'Votre commande est validée et va être prise en charge par nos équipes. Merci !',
    preparing: 'Il y a le feu en cuisine. Vous recevrez prochainement une notification quand votre commande sera prête.',
    delivering: 'Votre commande est prête. Vous serez livré dans les prochaines minutes, encore un peu de patience !',
    picking: 'Votre commande est prête. Vous pouvez dès à présent la retirer sur place, encore un petit effort !',
    done: 'Votre commande a été délivrée. Nous espérons que tout s\'est bien passé. Au plaisir de vous revoir.',
    cancelled: 'Votre commande a été annulée.'
  },
  ROLE_DELIVERY: {
    pending: 'La commande n\'est pas validée et est en attente de règlement. Vous ne pouvez actuellement pas la prendre en charge.',
    confirmed: 'La commande est validée et a été envoyée en cuisine. Vous ne pouvez actuellement pas la prendre en charge',
    preparing: 'La commande est en cours de préparation, il y a le feu en cuisine. Tenez-vous prêt pour une prise en charge !',
    delivering: 'Le client a été notifié, on compte sur vous pour une livraison express !',
    done: 'La commande a été annulée'
  }
};

export const TRANSACTION_STATUS = {
  pending: {
    slug: 'pending',
    label: 'En attente de paiement'
  },
  paid: {
    slug: 'paid',
    label: 'Paiement effectué'
  },
  paid_account: {
    slug: 'paid_account',
    label: 'Paiement mis en compte'
  },
  refused: {
    slug: 'refused',
    label: 'Paiement refusé'
  },
  cancelled: {
    slug: 'cancelled',
    label: 'Paiement annulé'
  },
  refunded: {
    slug: 'refunded',
    label: 'Paiement remboursé'
  }
};

export const TRANSACTION_STATUS_INFORMATIONS = {
  pending: 'Il semblerait que vous ayez quitté le processus de paiement trop tôt. Nous vous recommandons de vérifier une potentielle confirmation dans vos emails (y compris vos spams).',
  paid: 'Merci ! Votre règlement a bien été effectué. Votre commande est désormais validée et va être traitée par nos équipes.',
  refused: 'Ho non ! Votre paiement a échoué. Nous vous recommandons de ressayer une nouvelle fois. Si le problème persiste, veuillez contacter votre banque pour obtenir le motif du refus.',
  cancelled: 'Votre transaction a été annulée.',
  refunded: 'Votre transaction a été remboursée.'
};

export const USER_ROLES = {
  ROLE_OWNER: 'ROLE_OWNER',
  ROLE_SALE: 'ROLE_SALE',
  ROLE_ACCOUNTANT: 'ROLE_ACCOUNTANT',
  ROLE_USER: 'ROLE_USER',
  ROLE_PRO: 'ROLE_PRO',
  ROLE_DELIVERY: 'ROLE_DELIVERY',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ROLE_CASHIER: 'ROLE_CASHIER'
};

export class AppVersion {

  ios: {
    id: string
    currentVersion: string,
    requiredVersion: string
  };
  android: {
    id: string
    currentVersion: string,
    requiredVersion: string
  };

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class ManagerVersion {

  ios: {
    id: string
    version: string
  };
  android: {
    id: string
    version: string
  };

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class PaginatedResult<T> {
  items: T[];
  total: number;
  page: number;
  perPage: number;
  pages: number;

  constructor(obj: any, type: new (obj: any) => T) {
    Object.assign(this, obj);
    this.items = obj.items?.map(i => new type(i));
  }

}

export class OrderError {
  static readonly ERROR_NOT_USER = 'not_user';
  static readonly ERROR_PRODUCT_STOCK = 'product_stock';
  static readonly ERROR_INGREDIENT_STOCK = 'ingredient_stock';
  static readonly ERROR_CHOICE_STOCK = 'choice_stock';
  static readonly ERROR_DELIVERY_SLOT_INVALID = 'delivery_slot_invalid';
  static readonly ERROR_SC_OPTION_STOCK = 'sc_option_stock';
  static readonly ERROR_CHOICE_GROUP = 'choice_group';
  static readonly ERROR_DELIVERY_NOT_SUPPORTED = 'delivery_not_supported';
  static readonly ERROR_PICKUP_NOT_SUPPORTED = 'pickup_not_supported';
  static readonly ERROR_MIN_AMOUNT_NOT_REACHED = 'min_amount_not_reached';

  code: number = null;
  error = '';
  message: '';
  data: any = null;
  products: string[] = [];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class Restaurant {
  id: string;
  ref: string;
  name = '';
  address: Address;
  deliveryMinimum = 0;
  deliveryPrice = 0;
  allowDelivery = false;
  allowPickup = false;
  minimumTimeBeforeDelivery = 0;
  minimumTimeBeforePickup = 0;
  deliverySlotDuration = 0;
  pickupSlotDuration = 0;
  message = null;
  image: string;
  logo: string;
  description: string;
  deliveryZone: { lat: number, lng: number }[];
  openingHours: Hour[];
  deliveryHours: Hour[];
  orderLimitPerSlot: number;
  phone: string;
  deliverySlotsGenerateDays: number;
  manageStocks: boolean;
  mode: 'test' | 'production' = 'production';

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.address = new Address(obj.address);
    this.openingHours = (obj?.openingHours || []).map(o => new Hour(o));
    this.deliveryHours = (obj?.deliveryHours || []).map(o => new Hour(o));
  }

  toString() {
    return this.name;
  }

  imageFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.image);
  }

  logoFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.logo);
  }

}

export class RestaurantClosure {
  id: string;
  startsAt: string;
  endsAt: string;
  restaurant: Restaurant;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.restaurant = obj.restaurant ? new Restaurant(obj.restaurant) : null;
  }

  formattedStartDate(): string {
    return moment(this.startsAt).format('D MMMM YYYY');
  }

  formattedEndDate(): string {
    return moment(this.endsAt).format('D MMMM YYYY');
  }

  formattedStartTime(): string {
    return moment(this.startsAt).format('HH:mm');
  }

  formattedEndTime(): string {
    return moment(this.endsAt).format('HH:mm');
  }

}

export class RestaurantStats {
  ordersCount: number;
  ordersAmount: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class Company {
  id: string;
  name: string;
  code: string;
  registrationNumber: string;
  description: string;
  events: EventCompany[];
  address: Address;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.events = obj?.events?.map(a => new EventCompany(a)) || [];
    this.address = obj.address ? new Address(obj.address) : null;
  }

  getEventCompany(eventId: string): EventCompany {
    return this.events.find(e => e.event.id === eventId);
  }

}

export class Table {
  id: string;
  position: number;
  name: string;
  guestCount: number;
  x: number;
  y: number;
  zone: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class TableManagement {
  id: string;
  table: string;
  orders: string[] = [];
  order: string;
  guestCount: number;
  open: boolean = false;
  enabled: boolean = true;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export class Zone {
  id: string;
  position: number;
  name: string;
  restaurant: Restaurant;
  tables: Table[];
  objects: ZoneObject[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.tables = obj?.tables?.map(t => new Table(t)) || [];
    this.objects = obj?.objects?.map(o => new ZoneObject(o)) || [];
    this.restaurant = obj.restaurant ? new Restaurant(obj.restaurant) : null;
  }

}

export class ZoneObject {
  type: string;
  x: number;
  y: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export class Employee {
  id: string;
  firstname: string;
  lastname: string;
  pin: string;
  team: Team;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj?.hasOwnProperty('team')) {
      this.team = new Team(obj.team);
    }
  }

}

export class Team {
  id: string;
  name: string;
  permissions: string[];
  restaurant: Restaurant;
  employees: Employee[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.restaurant = obj?.restaurant ? new Restaurant(obj.restaurant) : null;
    this.employees = obj?.employees?.map(e => new Employee(e)) || [];
  }

}

export class PosReport {
  id: string;
  session: Session | string;
  items: PosReportItem[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.items = obj?.items?.map(i => new PosReportItem(i)) || [];
    if (obj?.hasOwnProperty('session')) {
      this.session = typeof obj.session === 'string' ? obj.session : new Session(obj.session);
    }
  }

}

export class PosReportItem {
  id: string;
  action: string;
  employee: string;
  originEmployee: Employee;
  data: string;
  createdAt: string;
  hash: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj?.hasOwnProperty('originEmployee')) {
      this.originEmployee = typeof obj.originEmployee === 'string' ? obj.originEmployee : new Employee(obj.originEmployee);
    }
  }

}

export class Tag {
  id: string;
  name: string;
  slug: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class Address {
  id: string;
  name: string;
  company: string;
  line1: string;
  line2: string;
  zip: string;
  city: string;
  details: string;

  constructor(obj?: any) {
    if (obj) {
      Object.assign(this, obj);
    }
  }

  toString() {
    return this.name;
  }

}

export class UserRegister {
  firstname: string;
  lastname: string;
  mobilePhone: string;
  email: string;
  plainPassword: string;
  plainPasswordConfirmation: string;
  companyCode: string;

  constructor() { }

}

export class ClientConfig {
  id: string;
  ticketLogo: string;
  ticketLogoWidth: number;
  ticketLogoHeight: number;
  /** @deprecated */
  appConfiguration: AppConfiguration;
  /** @deprecated */
  websiteConfiguration: WebsiteConfiguration;
  configuration: Configuration;
  cssConfiguration: string;
  termsHtml: string;
  /** @deprecated */
  logo: string;
  /** @deprecated */
  pattern: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('appConfiguration')) {
      this.appConfiguration = new AppConfiguration(obj.appConfiguration);
    }
    if (obj.hasOwnProperty('websiteConfiguration')) {
      this.websiteConfiguration = new WebsiteConfiguration(obj.websiteConfiguration);
    }
    if (obj.hasOwnProperty('configuration')) {
      this.configuration = new Configuration(obj.configuration);
    }
  }

}

export class Configuration {

  banner: {
    text: string
  };
  extensions: string[];
  shoppingCart: {
    infos: string
  };
  legalUrl: string;
  paymentMethods: [
    {
      name: string
      ref: string
      paymentReturnURL: string
    }
  ];
  stores: {
    playStore: {
      link: string
      package: string
    }
    appStore: {
      link: string
      package: string
    }
  };
  socials: [
    {
      link: string
      icon: string
    }
  ];
  deliveryInformations: string;
  contact: {
    map: {
      zoom: number
      center: {
        lat: number
        lng: number
      },
      markers: [
        {
          lat: number
          lng: number
        },
        {
          lat: number
          lng: number
        }
      ]
    }
  };
  app: {
    statusBarStyle: string;
  };
  website: {
    gtagId: string;
    footer: {
      widget1: string
      widget2: string
      photoCredits: {
        link: string
        name: string
      }
    }
  };
  gtagId: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class AppConfiguration extends Configuration {
  headerTheme: string;

  constructor(obj: any = {}) {
    super(obj);
  }

}

export class WebsiteConfiguration extends Configuration {
  footer: {
    widget1: string
    widget2: string
    photoCredits: {
      link: string
      name: string
    }
  };
  contact: {
    map: {
      zoom: number
      center: {
        lat: number
        lng: number
      },
      markers: [
        {
          lat: number
          lng: number
        },
        {
          lat: number
          lng: number
        }
      ]
    }
  };
  gtagId: string;

  constructor(obj: any = {}) {
    super(obj);
  }

}

export class Client {
  id: string;
  name: string;
  isActive: boolean;
  ref: string;
  extensions: string[];
  logo: string;
  publicUrl: string;
  paymentMethods: string[];
  vatNumber: string;
  companyNumber: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  logoFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.logo);
  }

}

export class ClientBilling {

  mmcv: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class User {
  static roles: { [key: string]: any; } = {
    ROLE_OWNER: {
      slug: 'ROLE_OWNER',
      label: 'Propriétaire'
    },
    ROLE_SALE: {
      slug: 'ROLE_SALE',
      label: 'Commercial'
    },
    ROLE_ACCOUNTANT: {
      slug: 'ROLE_ACCOUNTANT',
      label: 'Comptable'
    },
    ROLE_USER: {
      slug: 'ROLE_USER',
      label: 'Utilisateur'
    },
    ROLE_PRO: {
      slug: 'ROLE_PRO',
      label: 'Professionnel'
    },
    ROLE_DELIVERY: {
      slug: 'ROLE_DELIVERY',
      label: 'Livreur'
    },
    ROLE_ADMIN: {
      slug: 'ROLE_ADMIN',
      label: 'Admin'
    },
    ROLE_SUPER_ADMIN: {
      slug: 'ROLE_SUPER_ADMIN',
      label: 'Super admin'
    },
    ROLE_CASHIER: {
      slug: 'ROLE_CASHIER',
      label: 'Caissier'
    }
  };
  id: string;
  firstname: string;
  lastname: string;
  apiKey: string;
  addresses: Address[];
  mobilePhone: string;
  email: string;
  role: string;
  client: Client;
  company: Company;
  restaurants: Restaurant[];
  plainPassword: string;
  notifyOnRegister: boolean = true;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.addresses = obj.addresses?.map(a => new Address(a));
    if (obj.hasOwnProperty('client')) {
      this.client = new Client(obj.client);
    }
    if (obj.hasOwnProperty('company') && typeof obj.company !== 'string' && obj.company !== null) {
      this.company = new Company(obj.company);
    }
    this.restaurants = obj.restaurants?.map(r => new Restaurant(r));
  }

  isProUser(): boolean {
    return this.role === USER_ROLES.ROLE_PRO;
  }

  formattedRole(): string {
    return User.roles[this.role].label;
  }

}

export class OrderItemChoice {
  id = '';
  name = '';
  price = 0;
  quantity = 0;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class OrderItemChoiceGroup {
  id = '';
  name = '';
  choices: OrderItemChoice[] = [];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.choices = obj.choices?.map(c => new OrderItemChoice(c));
  }

  isSame(cg: OrderItemChoiceGroup): boolean {
    if (cg.name !== this.name || cg.choices?.length !== this.choices?.length) { return false; }
    for (const c of this.choices) {
      const sameChoice = cg.choices.findIndex(i => i.name === c.name && i.price === c.price && i.quantity === c.quantity) !== -1;
      if (!sameChoice) {
        return false;
      }
    }
    return true;
  }

}

export class Menu {
  id: string;
  name: string;
  price: number;
  restaurants: string[];
  category: string;
  groups: MenuGroup[];
  position: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.groups = (obj.groups || []).map(g => new MenuGroup(g));
  }

  hasProduct(id: string) {
    for (const g of this.groups) {
      if (g.hasProduct(id)) {
        return true;
      }
    }
    return false;
  }
}

export class MenuGroup {
  id: string;
  name: string;
  items: MenuGroupItem[];
  position: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.items = (obj.items || []).map(i => new MenuGroupItem(i));
  }

  hasProduct(id: string) {
    return this.items.findIndex(i => i.product === id) !== -1;
  }
}

export class MenuGroupItem {
  id: string;
  price: number;
  product: string;
  position: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export class OrderItem {
  id: string;
  type: 'product' | 'menu' | 'menu_item';
  name: string;
  quantity = 0;
  price = 0;
  menuItemPrice = 0;
  total = 0;
  vat = 0;
  vatRate: VatRate;
  kitchenItem = false;
  choiceGroups: OrderItemChoiceGroup[] = [];
  category: string;
  product: string;
  menu: string;
  originCategory: Category;
  originProduct: Product;
  originMenu: Menu;
  discount: OrderDiscount;
  items: OrderItem[];
  vats: OrderVat[];
  dimensionValue: number; // Division per 1000
  dimensionType: string;
  productionNote: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.choiceGroups = obj?.choiceGroups?.map(cg => new OrderItemChoiceGroup(cg)) || [];
    this.originCategory = obj.originCategory ? new Category(obj.originCategory) : null;
    this.originProduct = obj.originProduct ? new Product(obj.originProduct) : null;
    this.originMenu = obj.originMenu ? new Menu(obj.originMenu) : null;
    this.vatRate = obj.vatRate ? new VatRate(obj.vatRate) : null;
    this.discount = obj.discount ? new OrderDiscount(obj.discount) : null;
    this.items = (obj.items || []).map(i => new OrderItem(i));
    this.vats = (obj.vats || []).map(i => new OrderVat(i));
  }

  applyDiscount(value: string | number) {
    this.discount = null;
    this.recalculateTotals();
    const discountType = value.toString().indexOf('%') !== -1 ? 'percent' : 'fixed';
    let rate;
    let amount;
    if (discountType === 'percent') {
      rate = +(value.toString().split('%')[0]) / 100;
      amount = Math.round(this.total * rate);
    }
    if (discountType === 'fixed') {
      amount = +value * 100;
      rate = amount / this.total;
    }
    if (amount > this.total || amount < 0) {
      return;
    }
    if (amount === 0) {
      this.discount = null;
    } else {
      this.discount = new OrderDiscount({
        id: uuidv4(),
        type: discountType,
        rate,
        amount
      });
    }
    this.recalculateTotals();
  }

  removeDiscount() {
    if (!this.discount) {
      return;
    }
    this.discount = null;
    this.recalculateTotals();
  }

  recalculateTotals() {
    let choicesPrice = 0;
    let menuItemsPrice = 0;
    for (const i of this.items) {
      i.recalculateTotals();
      menuItemsPrice += i.menuItemPrice;
      for (const cg of i.choiceGroups) {
        for (const c of cg.choices) {
          if (c.quantity > 0) {
            choicesPrice += c.price * c.quantity
          }
        }
      }
    }
    for (const cg of this.choiceGroups) {
      for (const c of cg.choices) {
        if (c.quantity > 0) {
          choicesPrice += c.price * c.quantity
        }
      }
    }
    this.total = (choicesPrice + menuItemsPrice + this.price) * this.quantity;
    if (this.discount) {
      this.discount.amount = Math.round(this.total * this.discount.rate);
      this.total -= this.discount.amount;
    }
    if (this.type === 'menu') {
      // Menu vats
      this.vat = 0;
      this.vats = [];
      let originalTotal = 0;
      for (const i of this.items) {
        i.recalculateTotals();
        originalTotal += i.total + i.menuItemPrice;
      }
      for (const i of this.items) {
        const part = ((i.total + i.menuItemPrice) / originalTotal) * 100;
        const menuItemTotal = (this.total / 100) * part;
        const vat = Math.round(menuItemTotal - (menuItemTotal / (1 + i.vatRate.rate)));
        if (!vat || vat === 0) {
          continue;
        }
        this.vat += vat;
        const vatIndex = this.vats.findIndex(v => v.rate === i.vatRate.rate);
        if (vatIndex === -1) {
          this.vats.push(new OrderVat({
            id: uuidv4(),
            amount: vat,
            rate: i.vatRate.rate,
            baseTotal: menuItemTotal - vat
          }));
        } else {
          this.vats[vatIndex].amount += vat;
          this.vats[vatIndex].baseTotal += menuItemTotal - vat;
        }
      }
      this.vats.sort((a, b) => a.rate > b.rate ? 1 : -1);
    }
    if (this.type !== 'menu') {
      // Product and MenuItem vat
      this.vat = Math.round(this.total - (this.total / (1 + this.vatRate.rate)));
      this.vats = [new OrderVat({
        id: uuidv4(),
        amount: this.vat,
        rate: this.vatRate.rate,
        baseTotal: this.total - this.vat
      })];
    }
  }

  hasTags(): boolean {
    return this.originProduct?.tags?.length > 0 || this.originCategory?.tags?.length > 0;
  }

  isSame(i: OrderItem): boolean {
    if (this.items.length !== i.items.length) { return false; }
    if (this.items.length > 0) {
      return this.hasSameItems(i.items);
    } else {
      // For Divers Products
      if (i.type === 'product' && this.type === 'product' && !i.originProduct && !this.originProduct) {
        if (i.originCategory.id === this.originCategory.id && i.price === this.price) {
          return true;
        } else {
          return false;
        }
      }
      // For Standard Products
      if (i.originProduct?.id !== this.originProduct?.id || i.price !== this.price) {
        return false;
      }
      return this.hasSameChoiceGroups(i.choiceGroups);
    }
  }

  hasSameItems(items: OrderItem[]) {
    for (const i of items) {
      const sameItem = this.items.find(s => s.isSame(i));
      if (sameItem === undefined) {
        return false;
      }
    }
    return true;
  }

  hasSameChoiceGroups(choiceGroups: OrderItemChoiceGroup[]): boolean {
    if (this.choiceGroups?.length !== choiceGroups?.length) { return false; }
    for (const cg of choiceGroups) {
      const sameChoiceGroup = this.choiceGroups.find(s => s.isSame(cg));
      if (sameChoiceGroup === undefined) {
        return false;
      }
    }
    return true;
  }

}

export class OrderOption {
  id = '';
  name = '';
  price = 0;
  vat = 0;
  quantity = 0;
  total = 0;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class Collection {
  id: string;
  order: string;
  items: CollectionItem[];
  operations: CollectionOperation[];
  transactions: CollectionTransaction[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.items = obj?.items?.map(i => new CollectionItem(i)) || [];
    this.operations = obj?.operations?.map(i => new CollectionOperation(i)) || [];
    this.transactions = obj?.transactions?.map(i => new CollectionTransaction(i)) || [];
  }

  reorderItems(items: OrderItem[]) {
    const filteredItems = items.filter(i => this.items.findIndex(oi => oi.orderItem.id === i.id) !== -1);
    const itemsByItems: { [key: string]: CollectionItem[] } = {};
    for (const fi of filteredItems) {
      itemsByItems[fi.id] = this.items.filter(s => s.orderItem.id === fi.id);
    }
    const itemsReordered = [];
    for (const value of Object.values(itemsByItems)) {
      for (const i of value) {
        itemsReordered.push(i);
      }
    }
    this.items = itemsReordered;
  }

}

export class CollectionItem {
  id: string;
  name: string;
  total: number;
  quantity: number;
  orderItem: OrderItem;
  group: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('orderItem') && obj.orderItem !== null) {
      this.orderItem = new OrderItem(obj.orderItem);
    }
  }

  update(orderItem: OrderItem) {
    this.name = orderItem.name;
    this.total = orderItem.total;
    this.quantity = orderItem.quantity;
    this.orderItem = orderItem;
  }

}

export class CollectionOperation {
  id: string;
  name: string;
  total: number;
  quantity: number;
  type: string;
  orderItems?: OrderItem[];
  group: string;
  division: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.orderItems = obj?.orderItems?.map(i => new OrderItem(i)) || [];
  }

  hasOrderItem(id: string) {
    return this.orderItems && this.orderItems.findIndex(s => s.id === id) !== -1;
  }

  hasOrderItemWithDiscount() {
    return this.orderItems && this.orderItems.filter(i => i.discount).length > 0;
  }

}

export class CollectionTransaction {
  id: string;
  externalId: string;
  ref: string;
  total: number;
  type: string;
  operations: CollectionOperation[];
  status: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.operations = obj?.operations?.map(i => new CollectionOperation(i)) || [];
  }

  hasOrderItem(id: string) {
    return this.operations && this.operations.findIndex(s => s.hasOrderItem(id)) !== -1;
  }
}

export class Production {
  id: string;
  order: string;
  lastAction: string;
  items: ProductionItem[];
  itemsToSend: ProductionItem[];
  itemsComing: ProductionItem[];
  tickets: ProductionTicket[];
  topPriority: number = null;
  mode: 'auto' | 'manual' = 'auto';

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.items = obj?.items?.map(i => new ProductionItem(i)) || [];
    this.itemsToSend = obj?.itemsToSend?.map(i => new ProductionItem(i)) || [];
    this.itemsComing = obj?.itemsComing?.map(i => new ProductionItem(i)) || [];
    this.tickets = obj?.tickets?.map(i => new ProductionTicket(i)) || [];
  }

  getLastTicket(exception: 'itemsToSend' | 'itemsComing' | 'itemsToCancel' = null): ProductionTicket {
    let ticket = null;
    if (!exception) {
      return this.tickets.length > 0 ? this.tickets[0] : null;
    }
    for (const i of this.tickets) {
      if (i[exception]?.length > 0) {
        continue;
      }
      return i;
    }
    return ticket;
  }

  durationSinceLastAction() {
    return moment().diff(moment(this.lastAction), 'minutes');
  }

  setOrderItems(items: OrderItem[]) {
    const itemsById = {};
    for (const i of items) {
      itemsById[i.id] = i;
      for (const mi of i.items) {
        itemsById[i.id] = mi;
      }
    }
    for (let i of this.itemsToSend) {
      if (itemsById[i.orderItem]) {
        i.originOrderItem = itemsById[i.orderItem];
      }
    }
    for (let i of this.itemsComing) {
      if (itemsById[i.orderItem]) {
        i.originOrderItem = itemsById[i.orderItem];
      }
    }
    for (let i of this.tickets) {
      i.setOrderItems(items);
    }
  }

  clearItemLists() {
    this.items = [];
    this.itemsToSend = [];
    this.itemsComing = [];
  }

  getTopPriority() {
    let priority = 1;
    for (const t of this.tickets.filter(t => t.itemsToCancel.length === 0)) {
      const itemsToSend = t.itemsToSend;
      const itemsComing = t.itemsComing;
      let p = 1;
      if (itemsComing.length > 0) {
        for (const i of t.itemsComing) {
          const itemPriority = i.originOrderItem?.originCategory?.productionPriority;
          if (itemPriority > p) {
            p = itemPriority;
          }
        }
      }
      if (itemsToSend.length > 0) {
        for (const i of t.itemsToSend) {
          const itemPriority = i.originOrderItem?.originCategory?.productionPriority;
          if (itemPriority > priority) {
            p = itemPriority;
          }
        }
      }
      priority = p;
    }
    return priority;
  }
}

export class ProductionItem {
  id: string;
  name: string;
  quantity: number;
  orderItem: string;
  originOrderItem: OrderItem;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('originOrderItem') && obj.originOrderItem !== null) {
      this.originOrderItem = new OrderItem(obj.originOrderItem);
    }
  }

}

export interface ProductionOrderDataInterface {
  id: string;
  source: string;
  name: string;
  number: string;
  ref: string;
  table: string;
  details: string;
  deliveryMethod: string;
  deliverySlot: string;
  guestCount: number;
}

export class ProductionTicket {
  id: string;
  number: string;
  createdAt: string;
  itemsToSend: ProductionItem[];
  itemsComing: ProductionItem[];
  itemsToCancel: ProductionItem[];
  order: string;
  orderData: ProductionOrderDataInterface;
  printer: string;
  copy = false;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.itemsToSend = obj?.itemsToSend?.map(i => new ProductionItem(i)) || [];
    this.itemsComing = obj?.itemsComing?.map(i => new ProductionItem(i)) || [];
    this.itemsToCancel = obj?.itemsToCancel?.map(i => new ProductionItem(i)) || [];
  }

  formattedType(): string {
    return this.itemsToCancel?.length === 0 ? 'Ticket de production' : 'Ticket d\'annulation';
  }

  formattedCreatedAt(format?: string): string {
    return moment(this.createdAt).format(format || 'dddd DD MMMM YYYY à HH:mm');
  }

  setOrderItems(items: OrderItem[]) {
    const itemsById = {};
    for (const i of items) {
      itemsById[i.id] = i;
      for (const mi of i.items) {
        itemsById[i.id] = mi;
      }
    }
    for (let i of this.itemsToSend) {
      if (itemsById[i.orderItem]) {
        i.originOrderItem = itemsById[i.orderItem];
      }
    }
    for (let i of this.itemsComing) {
      if (itemsById[i.orderItem]) {
        i.originOrderItem = itemsById[i.orderItem];
      }
    }
    for (let i of this.itemsToCancel) {
      if (itemsById[i.orderItem]) {
        i.originOrderItem = itemsById[i.orderItem];
      }
    }
  }

}

export class Session {
  id: string;
  openedAt: string;
  closedAt: string;
  type: 'pos';
  hashKey: string;
  firstOrderNumber: number;
  lastOrderNumber: number;
  previousSessionLastOrderNumber: number;
  firstInvoiceNumber: number;
  lastInvoiceNumber: number;
  previousSessionLastInvoiceNumber: number;
  previousSessionLastHash: string;
  uploaded: boolean = false;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  getNextOrderNumber() {
    if (this.firstOrderNumber) {
      return this.lastOrderNumber + 1;
    } else {
      return (this.previousSessionLastOrderNumber || 0) + 1;
    }
  }

  setOrderNumbers(n: number) {
    this.lastOrderNumber = n;
    if (!this.firstOrderNumber) {
      this.firstOrderNumber = n;
    }
  }

  getNextInvoiceNumber() {
    if (this.firstInvoiceNumber) {
      return this.lastInvoiceNumber + 1;
    } else {
      return (this.previousSessionLastInvoiceNumber || 0) + 1;
    }
  }

  setInvoiceNumbers(n: number) {
    this.lastInvoiceNumber = n;
    if (!this.firstInvoiceNumber) {
      this.firstInvoiceNumber = n;
    }
  }

  openedAtFormatted() {
    return moment(this.openedAt).format('D MMM à HH:mm');
  }

}

export class License {
  id: string;
  ref: string;
  createdAt: string;
  expiresAt: string;
  isEnabled: boolean;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  isValid(): boolean {
    return moment(this.expiresAt).isAfter(moment()) && this.isEnabled;
  }

  expiresAtFormatted(): string {
    return moment(this.expiresAt).format('D MMMM YYYY');
  }

}

export class TransactionPayment {
  id: string;
  label: string;
  type: string;
  amount: number;
  cashback: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  formattedType() {
    return PAYMENT_METHODS[this.type].label;
  }

  icon() {
    return PAYMENT_METHODS[this.type].icon;
  }
}

export class Hashes {
  orders: { [key: string]: Hash };
  transactions: { [key: string]: Hash };
  reportItems: { [key: string]: Hash };
  lastOrderHash: Hash;
  lastTransactionHash: Hash;
  lastReportItemHash: Hash;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (Object.keys(obj.orders).length > 0) {
      for (const [key, value] of Object.entries(obj.orders)) {
        this.orders[key] = new Hash(value);
      }
    }
    if (Object.keys(obj.transactions).length > 0) {
      for (const [key, value] of Object.entries(obj.transactions)) {
        this.transactions[key] = new Hash(value);
      }
    }
    if (Object.keys(obj.reportItems).length > 0) {
      for (const [key, value] of Object.entries(obj.reportItems)) {
        this.reportItems[key] = new Hash(value);
      }
    }
  }

}

export class Hash {
  objectId: string;
  value: string;
  rawValue: string;
  createdAt: string;
  type: 'order' | 'transaction' | 'report_item';

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class TransactionVat {
  id: string;
  rate: number;
  amount: number;
  baseTotal: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class TransactionPart {
  id: string;
  amount: number;
  mealsCount: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export class InvoiceData {
  mode: 'send' | 'file';
  customerData?: string;
  transactions: Transaction[];
  details?: boolean;
  mealsCount?: number;
  email: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }
}

export class Transaction {
  id: string;
  ref: string;
  number: string;
  externalId: string;
  status: string;
  /**
  * @deprecated
  */
  amount: number;
  currency: number;
  paid: boolean;
  refunded: boolean;
  error: string;
  platform: string;
  items: TransactionItem[];
  paymentMethod: string;
  payments: TransactionPayment[];
  cancellationReason: string;
  createdAt: string;
  vatTotal: number;
  total: number;
  vats: TransactionVat[];
  originalTransaction: string;
  printed = false;
  printCount: number = 0;
  order: string;
  invoiceNumber: number;
  invoiceCustomerData: string;
  parts: TransactionPart[] = [];
  user: User;
  note: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.items = obj?.items?.map(i => new TransactionItem(i)) || [];
    this.payments = obj?.payments?.map(p => new TransactionPayment(p)) || [];
    this.vats = obj?.vats?.map(v => new TransactionVat(v)) || [];
    this.parts = obj?.parts?.map(p => new TransactionPart(p)) || [];
    this.user = obj?.user ? new User(obj.user) : null;
  }

  formattedStatusInformations(): string {
    return TRANSACTION_STATUS_INFORMATIONS[this.status];
  }

  formattedCancellationReason() {
    return ORDER_CANCELLATION_REASONS[this.cancellationReason].label;
  }

  statusIcon(): string {
    switch (this.status) {
      case TRANSACTION_STATUS.paid.slug:
        return 'checkmark-circle';
      default:
        return 'alert-circle';
    }
  }

  formattedStatus(): string {
    return TRANSACTION_STATUS[this.status]?.label;
  }

  cancel() {
    this.status = ORDER_STATUS.cancelled.slug;
  }

  formattedCreatedAt(format?: string): string {
    return moment(this.createdAt).format(format || 'dddd DD MMMM YYYY à HH:mm');
  }

  recalculateTotals() {
    this.total = 0;
    this.vatTotal = 0;
    this.vats = [];
    for (const i of this.items) {
      this.total += i.total;
      this.vatTotal += i.vat;
      for (const v of i.vats) {
        const vatIndex = this.vats.findIndex(s => s.rate === v.rate);
        if (vatIndex === -1) {
          this.vats.push(new TransactionVat({
            id: uuidv4(),
            amount: v.amount,
            rate: v.rate,
            baseTotal: v.baseTotal
          }));
        } else {
          this.vats[vatIndex].amount += v.amount;
          this.vats[vatIndex].baseTotal += v.baseTotal;
        }
      }
      this.vats.sort((a, b) => a.rate > b.rate ? 1 : -1);
    }
  }

  getTotal(): number {
    return this.total ? this.total : this.amount;
  }

  getPartsTotal(): number {
    let partsTotal = 0;
    for (const p of this.parts) {
      partsTotal += p.amount;
    }
    return partsTotal;
  }

  canAddPart(amount: number): boolean {
    return (this.status === TRANSACTION_STATUS.paid.slug || this.status === TRANSACTION_STATUS.paid_account.slug)
      && !this.originalTransaction
      && amount >= 0
      && (this.getPartsTotal() + amount) <= this.total;
  }

}

export class TransactionItem {
  id: string;
  type: string;
  description: string;
  vat: number;
  total: number;
  vats: TransactionVat[];
  price: number;
  quantity: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.vats = obj?.vats?.map(v => new TransactionVat(v)) || [];
  }

}

export class OrderVat {
  id: string;
  rate: number;
  amount: number;
  baseTotal: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class Order {
  id: string;
  user: string;
  clientEmail: string;
  clientFirstname: string;
  clientLastname: string;
  clientPhoneNumber: string;
  cardDetails: string;
  createdAt: string;
  updatedAt: string;
  billingAddress: Address;
  deliveryAddress: Address;
  deliveryMethod: string;
  deliverySlot: string;
  hasKitchenItems: boolean = false;
  items: OrderItem[] = [];
  number: string;
  options: OrderOption[] = [];
  paymentStatus: string;
  ref: string;
  restaurant: Restaurant | string;
  status: string;
  total = 0;
  transactions: Transaction[] = [];
  vatTotal = 0;
  deliveredBy: User;
  paymentMethod: string;
  pickupStall: EventStall;
  deliveryStall: EventStall;
  printed: boolean = false;
  printCount: number = 0;
  details: string;
  cancellationReason: string;
  vats: OrderVat[] = [];
  source: 'website' | 'app' | 'pos';
  session: string | Session;
  employee: string;
  originEmployee: Employee;
  discount: OrderDiscount;
  synchronized: boolean;
  name: string;
  itemQuantity: number;
  table: string;
  originTable: Table;
  guestCount: number;
  transactionNote: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.deliveryAddress = obj?.deliveryAddress ? new Address(obj.deliveryAddress) : null;
    this.billingAddress = obj?.billingAddress ? new Address(obj.billingAddress) : null;
    this.items = obj?.items?.map(i => new OrderItem(i)) || [];
    this.options = obj?.options?.map(o => new OrderOption(o)) || [];
    this.restaurant = obj?.restaurant ? (typeof obj.restaurant === 'string' ? obj.restaurant : new Restaurant(obj.restaurant)) : null;
    this.transactions = obj?.transactions?.map(t => {
      const transaction = new Transaction(t);
      transaction.order = this.id;
      return transaction;
    }) || [];
    this.deliveredBy = obj?.deliveredBy ? new User(obj.deliveredBy) : null;
    this.pickupStall = obj?.pickupStall ? new EventStall(obj.pickupStall) : null;
    this.deliveryStall = obj?.deliveryStall ? new EventStall(obj.deliveryStall) : null;
    this.vats = obj?.vats?.map(v => new OrderVat(v)) || [];
    this.discount = obj?.discount ? new OrderDiscount(obj.discount) : null;
    this.originEmployee = obj?.originEmployee ? new Employee(obj.originEmployee) : null;
    this.session = obj?.session ? (typeof obj.session === 'string' ? obj.session : new Session(obj.session)) : null;
    this.originTable = obj?.originTable ? new Table(obj.originTable) : null;
    this.setItemQuantity();
  }

  setItemQuantity() {
    let qt = 0;
    for (const i of this.items) {
      qt += i.quantity;
    }
    this.itemQuantity = qt;
  }

  formattedCreatedAt(format?: string): string {
    return moment(this.createdAt).format(format || 'dddd DD MMMM YYYY à HH:mm');
  }

  formattedShortCreatedAt() {
    return Utils.toShortDateTime(this.createdAt);
  }

  formattedTimeCreatedAt() {
    return Utils.toTime(this.createdAt);
  }

  formattedDeliverySlot(format?: string) {
    return moment(this.deliverySlot).format(format || 'dddd DD MMMM YYYY à HH:mm');
  }

  formattedShortDeliverySlot() {
    return Utils.toShortDateTime(this.deliverySlot);
  }

  deliveryTime() {
    return Utils.toTime(this.deliverySlot);
  }

  shortClientName() {
    return this.clientFirstname + ' ' + this.clientLastname.charAt(0).toUpperCase() + '.';
  }

  formattedStatus() {
    return this.formatStatus(this.status);
  }

  formattedStatusInformations(role: string = USER_ROLES.ROLE_USER): string {
    if (this.status === 'delivering') {
      return this.deliveryMethod === 'delivery' ? ORDER_STATUS_INFORMATIONS[role].delivering : ORDER_STATUS_INFORMATIONS[role].picking;
    } else {
      return ORDER_STATUS_INFORMATIONS[role][this.status];
    }
  }

  formatStatus(status: string): string {
    switch (status) {
      case 'pending':
        return 'En attente de paiement';
      case 'confirmed':
        return 'Confirmée';
      case 'preparing':
        return 'En cours de préparation';
      case 'delivering':
        return this.deliveryMethod === 'delivery' ? 'En cours de livraison' : 'En attente de retrait';
      case 'done':
        return 'Terminée';
      case 'cancelled':
        return 'Annulée';
    }
    return null;
  }

  previousStatus(formatted: boolean = false): string {
    switch (this.status) {
      case 'confirmed':
        return formatted ? this.formatStatus('pending') : 'pending';
      case 'preparing':
        return formatted ? this.formatStatus('confirmed') : 'confirmed';
      case 'delivering':
        return formatted ? this.formatStatus('preparing') : 'preparing';
      case 'done':
        return formatted ? this.formatStatus('delivering') : 'delivering';
    }
    return null;
  }

  nextStatus(formatted: boolean = false): string {
    switch (this.status) {
      case 'confirmed':
        return formatted ? this.formatStatus('preparing') : 'preparing';
      case 'preparing':
        return formatted ? this.formatStatus('delivering') : 'delivering';
      case 'delivering':
        return formatted ? this.formatStatus('done') : 'done';
    }
    return null;
  }

  statusIcon(): string {
    switch (this.status) {
      case 'confirmed':
        return 'checkmark-circle-outline';
      case 'preparing':
        return 'flask';
      case 'delivering':
        return this.deliveryMethod === 'delivery' ? 'bicycle' : 'flag';
      case 'done':
        return 'checkmark-circle';
      default:
        return 'hourglass';
    }

  }

  getPaymentLink(): string {
    return LibConfiguration.generatePaymentLink(this.id);
  }

  getKitchenItems(): OrderItem[] {
    return this.items.filter((n) => n.kitchenItem).sort((n1, n2) => {
      if (n1.name > n2.name) {
        return 1;
      }

      if (n1.name < n2.name) {
        return -1;
      }

      return 0;
    });
  }

  canBePaid(): boolean {
    return this.status === 'pending' && moment().diff(moment(this.createdAt), 'minutes') <= 30;
  }

  canAddItem(): boolean {
    return this.source === 'pos' && this.status === 'pending';
  }

  formattedSource(): string {
    switch (this.source) {
      case 'website':
        return 'Site web';
      case 'app':
        return 'Application';
      case 'pos':
        return 'Point de vente';
      default:
        return 'Source inconnue';
    }
  }

  recalculateTotals() {
    this.total = 0;
    this.vatTotal = 0;
    this.vats = [];
    for (const i of this.items) {
      i.recalculateTotals();
      this.total += i.total;
      if (i.items?.length === 0) {
        if ((!i.vat || i.vat === 0)) {
          continue;
        }
        this.vatTotal += i.vat;
        const vatIndex = this.vats.findIndex(v => v.rate === i.vatRate.rate);
        if (vatIndex === -1 && i.vat > 0) {
          this.vats.push(new OrderVat({
            id: uuidv4(),
            amount: i.vat,
            rate: i.vatRate.rate,
            baseTotal: i.total - i.vat
          }));
        } else {
          this.vats[vatIndex].amount += i.vat;
          this.vats[vatIndex].baseTotal += i.total - i.vat;
        }
      }
      if (i.items?.length > 0) {
        for (const vat of i.vats) {
          this.vatTotal += vat.amount;
          const vatIndex = this.vats.findIndex(v => v.rate === vat.rate);
          if (vatIndex === -1) {
            this.vats.push(new OrderVat({
              id: uuidv4(),
              amount: vat.amount,
              rate: vat.rate,
              baseTotal: vat.baseTotal
            }));
          } else {
            this.vats[vatIndex].amount += vat.amount;
            this.vats[vatIndex].baseTotal += vat.baseTotal;
          }
        }
      }
    }
    this.vats.sort((a, b) => a.rate > b.rate ? 1 : -1);
    this.setItemQuantity();
  }

  transactionsTotal(): number {
    let total = 0;
    for (const t of this.transactions) {
      total += t.amount;
    }
    return total;
  }

  totalRemaining(): number {
    return this.total - this.transactionsTotal();
  }

  getNextTransactionNumber(): string {
    let c = this.transactions.length + 1;
    let n = ('' + c).padStart(3, '0');
    while (this.transactions.findIndex(t => t.number === n) !== -1) {
      c += 1;
      n = ('' + c).padStart(3, '0');
    }
    return n;
  }

  canClose() {
    const transactionsTotal = this.transactionsTotal();
    return this.source === 'pos'
      && this.status === ORDER_STATUS.pending.slug
      && transactionsTotal === this.total;
  }

  canCancel(): boolean {
    return this.source === 'pos' && !this.synchronized && this.status !== ORDER_STATUS.cancelled.slug;
  }

  hasItemsWithTags(): boolean {
    return this.items.filter(i => i.hasTags()).length > 0;
  }

  findCloneItems(item: OrderItem): OrderItem[] {
    return this.items?.filter(i => i.isSame(item));
  }

  durationSinceOrderTaken() {
    return moment().diff(moment(this.createdAt), 'minutes');
  }
}

export class OrderDiscount {
  id: string;
  type: 'percent' | 'fixed';
  rate: number;
  amount: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class PlaceOrder {
  /* REQUIRED FOR EVERYONE */
  source: string;
  paymentMethod: string;
  deliveryMethod: string;
  deliverySlot: string;
  items: any[];
  options: PlaceOrderOption[];
  restaurant: string;
  details: string;

  /* NOT EVENT AND LOGGED */
  billingAddress: string;

  /* NOT EVENT AND DELIVERY */
  deliveryAddress: string;

  /* EVENT */
  event: string;

  /* NOT LOGGED */
  client: PlaceOrderClient;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.options = obj?.options.map(o => new PlaceOrderOption(o)) || [];
  }

}

export class PlaceOrderOption {
  id: string;
  quantity: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class PlaceOrderClient {
  firstname: string = null;
  lastname: string = null;
  phoneNumber: string = null;
  email: string = null;
  billingAddress: Address = null;
  deliveryAddress: Address = null;
}

export class VatRate {
  id: string;
  name: string;
  rate: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class ContactModel {
  name = '';
  message = '';
  email = '';
}

export class DeliverySlot {
  label = '';
  id = '';
  startsAt = '';
  endsAt = '';
  isOpen = true;
  duration: number;
  method: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  toString(): string {
    return this.label;
  }

  dayFormatted() {
    return moment(this.startsAt).format('dddd D MMMM');
  }

  shortDayFormatted() {
    return moment(this.startsAt).format('ddd D MMM');
  }

  fullDateFormatted(): string {
    const today = moment().isSame(this.startsAt, 'day');
    return today ? 'Aujourd\'hui, ' + this.label : moment(this.startsAt).format('dddd D MMM, ') + this.label;
  }

}

export class NextDeliverySlots {
  shop: DeliverySlot = null;
  delivery: DeliverySlot = null;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('shop') && obj.shop !== null) {
      this.shop = new DeliverySlot(obj.shop);
    }
    if (obj.hasOwnProperty('delivery') && obj.delivery !== null) {
      this.delivery = new DeliverySlot(obj.delivery);
    }
  }

}

export class DeliverySlots {

  shop: { [day: string]: DeliverySlot[] };
  delivery: { [day: string]: DeliverySlot[] };

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.shop) {
      this.shop = {};
      for (const [key, value] of Object.entries<[]>(obj.shop)) {
        this.shop[key] = value.map(d => new DeliverySlot(d));
      }
    }
    if (this.delivery) {
      this.delivery = {};
      for (const [key, value] of Object.entries<[]>(obj.delivery)) {
        this.delivery[key] = value.map(d => new DeliverySlot(d));
      }
    }
  }

}

export class Hour {
  id: string;
  day: number;
  closingTime: string;
  openingTime: string;
  /**
   * @deprecated Use only closingTime and openingTime on newest versions
   */
  midDayClosingTime: string;
  /**
   * @deprecated Use only closingTime and openingTime on newest versions
   */
  midDayOpeningTime: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  getFormattedSlot(format: string = 'HH:mm'): string {
    return moment(this.openingTime).format(format) + ' - ' + moment(this.closingTime).format(format);
  }

}

export class HourGroup {
  hours: Hour[];
  publicName: string;
  publicDescription: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.hours = obj?.hours?.map(h => new Hour(h));
  }

}

export class Category {
  id: string;
  name: string;
  slug: string;
  kitchen = false;
  products: Product[] = [];
  menus: Menu[] = [];
  ingredients: ProductIngredient[] = [];
  hours: HourGroup[];
  isEnabled: true;
  color: string;
  units: number; // In admin only
  tags: Tag[];
  productionPriority = 0;
  availableOnPos: boolean = true;
  availableOnWeb: boolean = true;
  availableOnMenu: boolean = true;
  vatRate: VatRate;
  canCreateProductOnPos = false;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.products = obj?.products?.map(p => new Product(p)) || [];
    this.menus = obj?.menus?.map(m => new Menu(m)) || [];
    this.ingredients = obj?.ingredients?.map(i => new ProductIngredient(i)) || [];
    this.hours = obj?.hours?.map(h => new HourGroup(h)) || [];
    this.tags = (obj?.tags?.map(t => new Tag(t))) || [];
    this.vatRate = obj?.vatRate ? new VatRate(obj.vatRate) : null;
  }

  toString() {
    return this.name;
  }

  removableIngredients(): ProductIngredient[] {
    return this.ingredients.filter(i => i.isRemovable);
  }

  addableIngredients(): ProductIngredient[] {
    return this.ingredients.filter(i => i.isAddable);
  }

}

export class Stock {
  id: string;
  restaurant: Restaurant;
  hasStock: boolean;
  isEnabled: boolean;
  currentQuantity: number;
  entity: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj?.restaurant) {
      this.restaurant = new Restaurant({
        id: obj.restaurant.id
      });
    }
  }

}

export class ProductChoice extends Sortable {
  static readonly PRODUCT_CHOICE_TYPE_CUSTOM = 'custom';
  static readonly PRODUCT_CHOICE_TYPE_INGREDIENT = 'ingredient';

  id: string;
  name: string;
  price: number;
  type = ProductChoice.PRODUCT_CHOICE_TYPE_CUSTOM;
  isEnabled: boolean;
  stocks: Stock[];
  ingredient: ProductIngredient;
  isDefault = false;

  constructor(obj: any = {}) {
    super();
    Object.assign(this, obj);
    if (this.type === ProductChoice.PRODUCT_CHOICE_TYPE_CUSTOM) {
      this.stocks = obj?.stocks?.map(s => new Stock(s)) || [];
    } else {
      this.ingredient = new ProductIngredient(obj.ingredient);
      this.stocks = this.ingredient.stocks;
    }
    this.price = this.type === ProductChoice.PRODUCT_CHOICE_TYPE_CUSTOM ? obj.price : this.ingredient.price;
    this.name = this.type === ProductChoice.PRODUCT_CHOICE_TYPE_CUSTOM ? obj.name : this.ingredient.name;
  }

}

export class ProductChoiceGroup extends Sortable {
  id: string;
  name: string;
  maxChoices: number;
  required: boolean;
  minChoices: number;
  useQuantitySelector: boolean;
  choices: ProductChoice[];
  selectorType: string = null;
  product: string;

  constructor(obj: any = {}) {
    super();
    Object.assign(this, obj);
    this.choices = obj?.choices?.map(c => new ProductChoice(c)) || [];
    if (this.minChoices === 1 && this.maxChoices === 1) {
      this.selectorType = 'radio';
    } else if (this.useQuantitySelector === false) {
      this.selectorType = 'checkbox';
    } else {
      this.selectorType = 'quantity';
    }
  }

}

export class ProductIngredient {
  id: string;
  name: string;
  price: number;
  vatRate: VatRate;
  stocks: Stock[];
  isRemovable: boolean;
  isAddable: boolean;
  productCategories: Category[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('vatRate')) {
      this.vatRate = new VatRate(obj.vatRate);
    }
    this.stocks = obj?.stocks?.map(s => new Stock(s)) || [];
    this.productCategories = obj?.productCategories?.map(c => new Category(c)) || [];
  }

}

export class ProductAllergen {
  id: string;
  name: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class Product {
  id: string;
  ref: string;
  name: string;
  image: string;
  description: string;
  price: number;
  vatRate: VatRate;
  allergens: ProductAllergen[];
  stocks: Stock[];
  choiceGroups: ProductChoiceGroup[];
  ingredients: ProductIngredient[];
  canRemoveIngredients: boolean;
  canAddIngredients: boolean;
  category: string;
  originCategory: Category;
  isEnabled: boolean;
  tags: Tag[];
  productionPriority: number;
  position: number;
  availableOnPos: boolean = true;
  availableOnWeb: boolean = true;
  availableOnMenu: boolean = true;
  dimensionType: 'unit'|'kg'|'m';
  isOption: boolean = false;
  color: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.vatRate = obj?.vatRate ? new VatRate(obj.vatRate) : null;
    this.stocks = obj?.stocks?.map(s => new Stock(s)) || [];
    this.choiceGroups = obj?.choiceGroups?.map(cg => new ProductChoiceGroup(cg)) || [];
    this.ingredients = obj?.ingredients?.map(i => new ProductIngredient(i)) || [];
    this.tags = obj?.tags?.map(i => new Tag(i)) || [];
    this.allergens = obj?.allergens?.map(i => new ProductAllergen(i)) || [];
    this.originCategory = obj?.originCategory ? new Category(obj.originCategory) : null;
  }

  formattedName() {
    return this.name;
  }

  formattedPrice() {
    return this.price / 100;
  }

  removableIngredients(): ProductIngredient[] {
    return this.ingredients.filter(i => i.isRemovable);
  }

  imageFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.image);
  }

  hasRequiredConfiguration(): boolean {
    return this.choiceGroups?.filter(cg => cg.required).length > 0;
  }

  dimensionTypeFormatted() {
    return PRODUCT_DIMENSION_TYPES[this.dimensionType].label;
  }
}

export class ShoppingCartOption {
  id: string;
  name: string;
  price: number;
  type: 'quantity' | 'checkbox';
  vatRate: VatRate;
  isEnabled: boolean;
  stocks: Stock[];
  restaurants: Restaurant[];
  maxChoices: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.vatRate = obj?.vatRate ? new VatRate(obj.vatRate) : null;
    this.stocks = obj?.stocks?.map(s => new Stock(s)) || [];
    this.restaurants = obj?.restaurants?.map(r => new Restaurant(r)) || [];
  }

}

export class ShoppingCartItemProductChoices {
  base: ProductChoiceGroup;
  choices: { choice: ProductChoice, quantity: number }[];
}

export class ShoppingCart {

  id: string = null;
  items: ShoppingCartItem[] = [];
  unvalidItems: string[] = [];
  createdAt: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.items = obj?.items?.map(i => new ShoppingCartItem(i)) || [];
  }

}

export class ShoppingCartItem {

  id: string = null;
  base: {
    product: Product,
    category: Category,
    quantity: number
  };
  choiceGroups: {
    [id: string]: ShoppingCartItemProductChoices
  };
  ingredientsToRemove: ProductIngredient[];
  ingredientsToAdd: ProductIngredient[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.base.product = obj.base?.product ? new Product(obj.base.product) : null;
    this.base.category = obj.base?.category ? new Category(obj.base.category) : null;
    this.ingredientsToRemove = obj?.ingredientsToRemove?.map(i => new ProductIngredient(i)) || [];
    this.ingredientsToAdd = obj?.ingredientsToAdd?.map(i => new ProductIngredient(i)) || [];
  }

  total(): number {
    let choicesTotalPrice = 0;
    let ingredientsToAddTotalPrice = 0;
    for (const [key, value] of Object.entries(this.choiceGroups)) {
      for (const c of value.choices) {
        choicesTotalPrice += c.choice.price * c.quantity;
      }
    }
    for (const i of this.ingredientsToAdd) {
      ingredientsToAddTotalPrice += i.price;
    }
    return ((this.base.product.price + choicesTotalPrice + ingredientsToAddTotalPrice) * this.base.quantity);
  }

  vat(): number {
    return this.total() - (this.total() / (1 + this.base.product.vatRate.rate));
  }

  setQuantity(quantity: number) {
    this.base.quantity = quantity;
  }

  getChoiceGroups(): ShoppingCartItemProductChoices[] {
    const choiceGroups = [];
    for (const [key, value] of Object.entries(this.choiceGroups)) {
      choiceGroups.push(value);
    }
    return choiceGroups;
  }

}

export interface JWTTokenInterface {
  token: string;
  client?: string;
  tabletId?: string;
}

export interface ErrorInterface {
  message: string;
  error: string;
  code: number;
}

/* WIDGET */

export class Widget {
  id: string;
  slug: string;
  type: 'gallery' | 'custom';
  title: string;
  items: WidgetGalleryItem[] | WidgetCustomItem[];
  restaurants: Restaurant[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.type === 'gallery') {
      this.items = obj?.items?.map(i => i.type === 'image' ? new WidgetGalleryImageItem(i) : new WidgetGalleryTextItem(i)) || [];
    }
    if (obj.type === 'custom') {
      this.items = obj?.items?.map(i => {
        if (i.type === 'custom') { return new WidgetCustomCustomItem(i); }
        if (i.type === 'category') { return new WidgetCustomCategoryItem(i); }
        if (i.type === 'product') { return new WidgetCustomProductItem(i); }
      }) || [];
    }
    this.restaurants = obj?.restaurants?.map(r => new Restaurant(r)) || [];
  }
}

export class WidgetItem {
  id: string;
  image: string;
  position: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  imageFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.image);
  }

}

export class WidgetGalleryItem extends WidgetItem {
  type: 'text' | 'image';
  size: 's' | 'm' | 'l';

  constructor(obj: any = {}) {
    super(obj);
  }

}

export class WidgetGalleryImageItem extends WidgetGalleryItem {

  constructor(obj: any = {}) {
    super(obj);
  }

}

export class WidgetGalleryTextItem extends WidgetGalleryItem {
  title: string;
  text: string;

  constructor(obj: any = {}) {
    super(obj);
  }

}

export class WidgetCustomItem extends WidgetItem {
  type: 'custom' | 'product' | 'category';
  title: string;
  text: string;

  constructor(obj: any = {}) {
    super(obj);
  }

}

export class WidgetCustomCustomItem extends WidgetCustomItem {
  action: 'menu' | null;
  file: string;

  constructor(obj: any = {}) {
    super(obj);
  }

  fileFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.file);
  }

}

export class WidgetCustomCategoryItem extends WidgetCustomItem {
  category: Category;

  constructor(obj: any = {}) {
    super(obj);
    this.category = obj.hasOwnProperty('category') && obj.category ? new Category(obj.category) : null;
  }

}

export class WidgetCustomProductItem extends WidgetCustomItem {
  product: Product;

  constructor(obj: any = {}) {
    super(obj);
    this.product = obj.hasOwnProperty('product') && obj.product ? new Product(obj.product) : null;
  }

}

/* EVENTS */

export class Event {
  id: string;
  ref: string;
  name: string;
  description: string;
  startsAt: string;
  endsAt: string;
  location: EventLocation;
  eventRestaurants: EventRestaurant[] = null;
  halls: EventHall[] = null;
  image: string;
  logo: string;
  companies: EventCompany[] = null;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.eventRestaurants = obj?.eventRestaurants?.map(er => new EventRestaurant(er)) || [];
    this.halls = obj?.halls?.map(h => new EventHall(h)) || [];
    this.companies = obj?.companies?.map(c => new EventCompany(c)) || [];
    this.location = obj?.location ? new EventLocation(obj.location) : null;
  }

  getEventRestaurantByRestaurantId(restaurantId: string): EventRestaurant {
    return this.eventRestaurants.find(er => er.restaurant.id === restaurantId);
  }

  getEventRestaurantsByHallId(hallId: string): EventRestaurant[] {
    return this.eventRestaurants.filter(er => er.stall.hall.id === hallId);
  }

  formattedDates(): string {
    return moment(this.startsAt).format('DD.MM.YYYY') + ' - ' + moment(this.endsAt).format('DD.MM.YYYY');
  }

  formattedStartDate(): string {
    return moment(this.startsAt).format('D MMMM');
  }

  formattedEndDate(): string {
    return moment(this.endsAt).format('D MMMM');
  }

  imageFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.image);
  }

  logoFullUrl(): string {
    return LibConfiguration.imageUrlFromPath(this.logo);
  }

}

export class EventLocation {
  id: string;
  name: string;
  halls: EventHall[];

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    this.halls = obj?.halls?.map(h => new EventHall(h)) || [];
  }

}

export class EventHall {
  id: string;
  name: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

}

export class EventStall {
  id: string;
  hall: EventHall = null;
  aisle: string;
  number: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('hall')) {
      this.hall = new EventHall(obj.hall);
    }
  }

}

export class EventRestaurant {
  id: string;
  restaurant: Restaurant = null;
  stall: EventStall = null;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('restaurant')) {
      this.restaurant = new Restaurant(obj.restaurant);
    }
    if (obj.hasOwnProperty('EventStall')) {
      this.stall = new EventStall(obj.stall);
    }
  }

}

export class EventCompany {

  id: string;
  event: Event;
  stall: EventStall;
  billedLater = false;
  company: Company;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
    if (obj.hasOwnProperty('event')) {
      this.stall = new EventStall(obj.stall);
    }
    if (obj.hasOwnProperty('stall')) {
      this.stall = new EventStall(obj.stall);
    }
    if (obj.hasOwnProperty('company')) {
      this.company = new Company(obj.company);
    }
  }

}
